export const REALM_SWEDEN = 'se';
export const REALM_UK = 'uk';


export const COUNTRY_CODE_SWEDEN = 'se';
export const COUNTRY_CODE_UK = 'uk';
